<div *ngIf="!fieldTemplate; else customTemplate" [id]="field.field + '_Item'" class="inputItem">
    <mat-form-field appearance="fill"
                    [color]="field.color" #item [style.z-index]="index">
        <mat-label [class]="field.field + '_Label'">{{field.label | translate}}</mat-label>
        <textarea matInput [id]="field.field" [formControl]="inputFormControl" [rows]="field.taRows" [readonly]="field.readonly" [placeholder]="placeholder"
                  (focus)="focus.emit($event)" (focusin)="focusin.emit($event)" (focusout)="focusout.emit($event)" (blur)="blur.emit($event)"></textarea>
        <div matSuffix class="matSuffix">
            <button *ngIf="field.withClearButton" type="button" tabindex="-1" mat-icon-button (click)="$event.stopPropagation(); inputFormControl.patchValue('')">
                <mat-icon>close</mat-icon>
            </button>
            <mat-generic-input-slot [control]="inputFormControl" [field]="field" [fieldAddonTemplates]="fieldAddonTemplates$ | async"></mat-generic-input-slot>
        </div>
        <mat-error *ngIf="!(field.selectSearchData?.selectData?.options | async)?.length">
            <mat-generic-input-hint type="error" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
        </mat-error>
        <mat-hint>
            <mat-generic-input-hint type="combined" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
        </mat-hint>
    </mat-form-field>
    <mat-progress-bar class="loading" color="warning" mode="indeterminate"
                      *ngIf="(inputFormControl?.statusChanges | async) === 'PENDING' || inputFormControl?.status === 'PENDING'"></mat-progress-bar>
</div>

<ng-template #customTemplate>
    <ng-container *ngTemplateOutlet="fieldTemplate.template, context: { $implicit: field, genericInput: this, formControl: inputFormControl, index: index }"></ng-container>
</ng-template>
